<template>
  <div class="after-sales-status">
    <template v-if="hasAfterSales">
      <div class="after-sales-badge" :class="statusClass">
        {{ $t(afterSalesStatusText) }}
      </div>
    </template>
  </div>
</template>

<script>
import { computed, ref, onMounted } from '@nuxtjs/composition-api';
import { SfBadge } from '@storefront-ui/vue';
import { useUserShouHouList } from '@bee-hole/coms';

export default {
  name: 'OrderAfterSalesStatus',
  components: {
    SfBadge
  },
  props: {
    orderId: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const afterSalesList = ref([]);
    const { shouhouGet, aftersalesList } = useUserShouHouList('afterSalesList_' + props.orderId);

    const hasAfterSales = computed(() => {
      return afterSalesList.value && afterSalesList.value.length > 0;
    });

    const afterSalesStatusText = computed(() => {
      if (!hasAfterSales.value) return 'After_Sales_Unknown';
      
      const hasFinished = afterSalesList.value?.some(item => item.status === 'finished');
      const allProcessing = afterSalesList.value?.every(item => item.status === 'processing');
      console.log('hasFinished', hasFinished, props.orderId);
      console.log('allProcessing', allProcessing);
      if (hasFinished) return 'finished';
      if (allProcessing) return 'processing';
      return 'After_Sales_Unknown';
    });

    const statusClass = computed(() => {
      if (!hasAfterSales.value) return '';
      
      const hasFinished = afterSalesList.value?.some(item => item.status === 'finished');
      const allProcessing = afterSalesList.value?.every(item => item.status === 'processing');
      
      if (hasFinished) return 'color-success';
      if (allProcessing) return 'color-warning';
      return '';
    });

    const fetchAfterSales = async () => {
      try {
        console.log('orderId', props.orderId);
        await shouhouGet({ order_id: props.orderId });
        afterSalesList.value = aftersalesList.value;
      } catch (error) {
        console.error('Error fetching after-sales status:', error);
      }
    };

    onMounted(() => {
      fetchAfterSales();
    });

    return {
      hasAfterSales,
      afterSalesStatusText,
      statusClass
    };
  }
};
</script>

<style lang="scss" scoped>
.after-sales-status {
  display: flex;
  align-items: center;
  gap: 1rem;

  .after-sales-badge {
    padding: 0.25rem 0;
    font-size: 0.875rem;
  }

  .color-warning {
    color: var(--c-warning);
  }

  .color-info {
    color: var(--c-info);
  }

  .color-success {
    color: var(--c-success);
  }

  .color-danger {
    color: var(--c-danger);
  }
}
</style>
